import { v4 as uuid } from "uuid";

export const DEFAULT_MILESTONE = [
  {
    name: "",
    dateRange: "",
    id: uuid(),
    tasks: [
      {
        description: "",
        id: uuid(),
        organization: "FKA",
        services: [
          {
            name: "Service Name",
            roles: [
              {
                name: "Role Name",
                assignee: "Assignee Name",
                duration: "",
                cost: "",
                rate: "",
              },
            ],
          },
        ],
        duration: "",
        cost: "",
        startDate: null,
        endDate: null,
        isRequired: true,
      },
    ],
    hours: 0,
    budget: 0,
    discount: 0,
    taxes: 0,
  },
];

export const DEFAULT_MATERIALS = [
  {
    budget: "",
    material: [
      {
        description: "",
        expenseType: "",
        quantity: "",
        cost: "",
        markup: "",
        override: "",
        total: "",
      },
    ],
  },
];

export const PROJECT_STATES_OPTIONS = [
  { label: "Opportunity", value: "Opportunity" },
  { label: "Committed", value: "Committed" },
  { label: "Active", value: "Active" },
  { label: "On Hold", value: "On Hold" },
  { label: "Cancelled", value: "Cancelled" },
  { label: "Complete", value: "Complete" },
];

export const PROJECT_SOURCE_OPTIONS = [
  { label: "RFP", value: "rfp" },
  { label: "New Lead", value: "newLead" },
  { label: "New Work", value: "newWork" },
];

export const COMPANY_STATES_OPTIONS = [
  { label: "Active", value: "Active" },
  { label: "Inactive", value: "Inactive" },
];

export const COMPANY_TYPE_OPTIONS = [
  { label: "Client", value: "Client" },
  { label: "Vendor", value: "Vendor" },
];

export const CONTACT_STATES_OPTIONS = [
  { label: "Active", value: "Active" },
  { label: "Inactive", value: "Inactive" },
];

export const CONTACT_TYPE_OPTIONS = [
  { label: "Primary", value: "Primary" },
  { label: "General", value: "General" },
  { label: "Accounting", value: "Accounting" },
];

export const COMPANY_PROVINCE_OPTIONS = [
  { label: "Alberta", value: "Alberta" },
  { label: "British Columbia", value: "British Columbia" },
  { label: "Manitoba", value: "Manitoba" },
  { label: "New Brunswick", value: "New Brunswick" },
  { label: "Newfoundland and Labrador", value: "Newfoundland and Labrador" },
  { label: "Northwest Territories", value: "Northwest Territories" },
  { label: "Nova Scotia", value: "Nova Scotia" },
  { label: "Nunavut", value: "Nunavut" },
  { label: "Ontario", value: "Ontario" },
  { label: "Prince Edward Island", value: "Prince Edward Islan" },
  { label: "Quebec", value: "Quebec" },
  { label: "Saskatchewan", value: "Saskatchewan" },
  { label: "Yukon", value: "Yukon" },
];

export const COMPANY_COUNTRY_OPTIONS = [
  { label: "Canada", value: "Canada" },
  { label: "US", value: "US" },
];

export const COMPANY_US_STATE_OPTIONS = [
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virginia", value: "VA" },
  { label: "Washington", value: "WA" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" },
];

export const ROLE_OPTIONS = [
  { label: "Media Coordinator", value: "Media Coordinator" },
  { label: "Senior Operations Manager", value: "Senior Operations Manager" },
  { label: "Service Delivery Manager", value: "Service Delivery Manager" },
  { label: "VP, Service Delivery", value: "VP, Service Delivery" },
  { label: "VP, Corporate Development", value: "VP, Corporate Development" },
  { label: "VP, Media Services", value: "VP, Media Services" },
  { label: "Media Manager", value: "Media Manager" },
  { label: "Strategist", value: "Strategist" },
  { label: "Senior Strategist", value: "Senior Strategist" },
  { label: "Account Director", value: "Account Director" },
  { label: "Art Director", value: "Art Director" },
  { label: "Media Strategist", value: "Media Strategist" },
  { label: "Media Director", value: "Media Director" },
  { label: "Office Administrator", value: "Office Administrator" },
  { label: "Creative Director", value: "Creative Director" },
  { label: "Design Director", value: "Design Director" },
  { label: "Senior Media Director", value: "Senior Media Director" },
  { label: "Communications Manager", value: "Communications Manager" },
  { label: "Developer", value: "Developer" },
  { label: "Graphic Designer", value: "Graphic Designer" },
  {
    label: "Associate Creative Director",
    value: "Associate Creative Director",
  },
  { label: "Accounting Manager", value: "Accounting Manager" },
  { label: "VP, Accounts", value: "VP, Accounts" },
  { label: "Interactive Designer", value: "Interactive Designer" },
  { label: "Interactive Coordinator", value: "Interactive Coordinator" },
  { label: "Consultant", value: "Consultant" },
];

export const SERVICE_GROUP_OPTIONS = [
  { label: "Media Services", value: "Media Services" },
  { label: "Operations", value: "Operations" },
  { label: "Service Delivery", value: "Service Delivery" },
  { label: "Strategy", value: "Strategy" },
  { label: "Client Services", value: "Client Services" },
  { label: "Creative Services", value: "Creative Services" },
  { label: "Corporate Development", value: "Corporate Development" },
  { label: "Interactive Services", value: "Interactive Services" },
];

export const PERMISSIONS_OPTIONS = [
  { label: "General", value: "General" },
  { label: "Admin", value: "Admin" },
  { label: "Project Manager", value: "Project Manager" },
  { label: "Supervisor", value: "Supervisor" },
];

export const EMPLOYMENT_STATUS_OPTIONS = [
  { label: "Active", value: "Active" },
  { label: "Inactive", value: "Inactive" },
  { label: "Contract", value: "Contract" },
];

export const DEFAULT_WORK_SCHEDULE = [
  { day: "Monday", hours: 0 },
  { day: "Tuesday", hours: 0 },
  { day: "Wednesday", hours: 0 },
  { day: "Thursday", hours: 0 },
  { day: "Friday", hours: 0 },
];

export const REVENUE_ACCOUNT_OPTIONS = [
  {
    label: "4070 - Media Services Revenue",
    value: "4070 - Media Services Revenue",
  },
  {
    label: "4075 - Client Services Revenue",
    value: "4075 - Client Services Revenue",
  },
  {
    label: "4080 - Creative Services Revenue",
    value: "4080 - Creative Services Revenue",
  },
  // { label: "4085 - Communication Services Revenue", value: "4085 - Communication Services Revenue" },
  // { label: "4090 - Interactive Services Revenue", value: "4090 - Interactive Services Revenue" },
  {
    label: "4092 - Service Delivery Revenue",
    value: "4092 - Service Delivery Revenue",
  },
];
